import React, { useState, useEffect } from 'react';
import PageContainer from '../components/containers/PageContainer';
import { Button, IconButton, TableCell, TableRow, Tooltip } from '@mui/material';
import api from '../config/axios';
import { toast } from 'react-toastify';
import Field from '../components/ui/Field';
import CustomTable from '../components/ui/CustomTable';
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import AttachMoneyOutlinedIcon from '@mui/icons-material/AttachMoneyOutlined';
import MoneyOffCsredOutlinedIcon from '@mui/icons-material/MoneyOffCsredOutlined';
import PersonOffOutlinedIcon from '@mui/icons-material/PersonOffOutlined';
import PersonOutlineOutlinedIcon from '@mui/icons-material/PersonOutlineOutlined';
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import LocalPoliceOutlinedIcon from '@mui/icons-material/LocalPoliceOutlined';
import PriceChangeIcon from '@mui/icons-material/PriceChange';
import RequestQuoteIcon from '@mui/icons-material/RequestQuote';
import { Stack } from '@mui/system';
import ModalContainer from '../components/containers/ModalContainer';
import StatusComp from '../components/common/StatusComp';
import { Link } from 'react-router-dom';
import PasswordIcon from '@mui/icons-material/Password';
const Workers = () => {
    const [users, setUsers] = useState([]);
    const [user, setUser] = useState('');
    const [loader, setLoader] = useState(false);
    const [filter, setFilter] = useState('All');
    const [sort, setSort] = useState('asc');
    const [page, setPage] = useState(1);
    const [limit, setLimit] = useState(10);
    const [totalPages, setTotalPages] = useState(0);

    const [showAddBalance, setShowAddBalance] = useState(false);
    const onCloseAddBalanceModal = () => {
        setShowAddBalance(false);
    };
    const onOpenAddBalanceModal = () => setShowAddBalance(true);

    const [showRemoveBalance, setShowRemoveBalance] = useState(false);
    const onCloseRemoveBalanceModal = () => {
        setShowRemoveBalance(false);
    };
    const onOpenRemoveBalanceModal = () => setShowRemoveBalance(true);

    const [showDeleteuser, setShowDeleteuser] = useState(false);
    const onCloseDeleteuserModal = () => {
        setShowDeleteuser(false);
    };
    const onOpenDeleteuserModal = () => setShowDeleteuser(true);

    const [showUser, setShowUser] = useState(false);
    const onCloseUserModal = () => {
        setShowUser(false);
    };
    const onOpenUserModal = () => setShowUser(true);

    const [addUser, setAddUser] = useState(false);
    const onCloseUserAddModal = () => {
        setAddUser(false);
    };
    const onOpenUserAddModal = () => setAddUser(true);

    const getUsers = async (search) => {
        const url = '/workers/read';
        var link = '';
        if (search) {
            link = url + '?page=' + page + '&limit=' + limit + '&search=' + search;
        } else {
            link = url + '?page=' + page + '&limit=' + limit;
        }

        await api
            .get(link)
            .then((res) => {
                setUsers(res.data.admins);
                setTotalPages(res.data.totalPages);
            })
            .catch((err) => {
                console.log(err);
            });
    };

    const DisableUser = async (id) => {
        await api
            .put('/workers/status/' + id, {})
            .then((res) => {
                getUsers();
                toast.success(res.data.message);
            })
            .catch((err) => {
                toast.error(err.response.data.message);
            });
    };

    const deleteUser = async (e) => {
        e.preventDefault();
        setLoader(true);

        const params = {
            id: user._id,
        };

        await api
            .delete(`/workers/delete/${params.id}`)
            .then((res) => {
                setLoader(false);
                toast.success(res.data.message);
                getUsers();
                onCloseDeleteuserModal();
            })
            .catch((err) => {
                setLoader(false);
                toast.error(err.response.data.message);
            });
    };

    useEffect(() => {
        getUsers();
    }, [page, limit]);

    const updatePassword = async (e) => {
        e.preventDefault();

        const data = {
            password: e.target.password.value,
        };

        await api
            .put('/workers/update/' + user._id, data)
            .then((res) => {
                setLoader(false);
                getUsers();
                toast.success(res.data.message);
                onCloseAddBalanceModal();
            })
            .catch((err) => {
                setLoader(false);
                toast.error(err.response.data.message);
            });
    };

    const addNewUser = async (e) => {
        e.preventDefault();

        const data = {
            username: e.target.username.value,
            password: e.target.password.value,
        };

        await api
            .post('/workers/create', data)
            .then((res) => {
                setLoader(false);
                getUsers();
                toast.success(res.data.message);
                onCloseUserAddModal();
            })
            .catch((err) => {
                setLoader(false);
                toast.error(err.response.data.message);
            });
    };

    return (
        <PageContainer
            title="Manage Workers"
            desc=" All your workers at one place"
            end={
                <Button variant="contained" onClick={() => onOpenUserAddModal()}>
                    Add Worker
                </Button>
            }>
            {/* <Field
                placeholder="Search users using name, email address"
                onChange={(e) => {
                    getUsers(e.target.value);
                }}
            /> */}
            <CustomTable
                sx={{ mt: 2 }}
                fields={['#', 'USERNAME', 'STATUS', 'CREATEDON', 'ACTION']}
                dense={false}
                loading={loader}
                pagination
                count={totalPages}
                page={page}
                setPage={setPage}>
                {users.map((user, index) => (
                    <TableRow key={index}>
                        <TableCell>{page > 1 ? (page - 1) * 10 + index + 1 : index + 1}</TableCell>
                        <TableCell>{user.username}</TableCell>

                        <TableCell>
                            <StatusComp status={user.status ? 'active' : 'inactive'} />
                        </TableCell>
                        <TableCell>{new Date(user.createdAt).toLocaleDateString()}</TableCell>

                        <TableCell>
                            <Stack direction="row">
                                <Tooltip title="Update Password">
                                    <IconButton
                                        color="warning"
                                        onClick={() => {
                                            setUser(user);
                                            onOpenAddBalanceModal();
                                        }}>
                                        <PasswordIcon fontSize="small" />
                                    </IconButton>
                                </Tooltip>

                                {user.status ? (
                                    <Tooltip title="Disable Worker">
                                        <IconButton
                                            color="success"
                                            onClick={() => {
                                                DisableUser(user._id);
                                            }}>
                                            <PersonOffOutlinedIcon fontSize="small" />
                                        </IconButton>
                                    </Tooltip>
                                ) : (
                                    <Tooltip title="Enable Worker">
                                        <IconButton
                                            color="error"
                                            onClick={() => {
                                                DisableUser(user._id);
                                            }}>
                                            <PersonOutlineOutlinedIcon fontSize="small" />
                                        </IconButton>
                                    </Tooltip>
                                )}
                                <Tooltip title="Delete Worker">
                                    <IconButton
                                        color="error"
                                        onClick={() => {
                                            setUser(user);
                                            onOpenDeleteuserModal();
                                        }}>
                                        <DeleteOutlineOutlinedIcon fontSize="small" />
                                    </IconButton>
                                </Tooltip>
                            </Stack>
                        </TableCell>
                    </TableRow>
                ))}
            </CustomTable>

            {/* Update Password */}
            <ModalContainer hideActions open={showAddBalance} onClose={onCloseAddBalanceModal} title="Update Password">
                <form onSubmit={updatePassword} className="form-validate is-alter">
                    <div className="form-group">
                        <label className="form-label" htmlFor="full-name">
                            New Password
                        </label>

                        <input type="text" name="password" placeholder="Enter new password" className="form-control" />
                    </div>

                    <div className="form-group mt-2 mb-2">
                        <Button variant="contained" type="submit">
                            Update
                        </Button>
                    </div>
                </form>
            </ModalContainer>

            {/* Delete worker */}
            <ModalContainer hideActions open={showDeleteuser} onClose={onCloseDeleteuserModal} title="Delete Worker">
                <form onSubmit={deleteUser}>
                    <div className="form-group mb-3">
                        <p>Are you sure you want to delete this WORKER?</p>
                    </div>

                    <div className="d-flex mt-2 justify-content-end ">
                        <Button type="button" onClick={onCloseDeleteuserModal}>
                            Close
                        </Button>
                        <Button type="submit" variant="contained" color="error">
                            Delete
                        </Button>
                    </div>
                </form>
            </ModalContainer>

            {/* Create User */}
            <ModalContainer hideActions open={addUser} onClose={onCloseUserAddModal} title="Add New User">
                <form onSubmit={addNewUser} className="form-validate is-alter">
                    <div className="form-group mb-2">
                        <label className="form-label" htmlFor="full-name">
                            Username
                        </label>

                        <input type="text" name="username" placeholder="Enter the username" className="form-control" />
                    </div>
                    <div className="form-group mb-2">
                        <label className="form-label" htmlFor="full-name">
                            Password
                        </label>

                        <input type="text" name="password" placeholder="Enter the password" className="form-control" />
                    </div>

                    <div className="form-group mt-2 mb-2">
                        <Button variant="contained" type="submit">
                            Create
                        </Button>
                    </div>
                </form>
            </ModalContainer>
        </PageContainer>
    );
};

export default Workers;
